import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

// Header enligt CHills Visuella-redesign (med riktig routing)
export const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const onHome = location.pathname === '/';
  const onService = location.pathname.startsWith('/tjanst');
  const onAbout = location.pathname === '/om';

  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 70, behavior: 'smooth' });
  };

  // Navigera hem och ev. scrolla till en sektion (Portfolio/Omdömen).
  const goHome = (anchor) => {
    setMenuOpen(false);
    if (!onHome) {
      navigate('/');
      if (anchor) setTimeout(() => scrollToSection(anchor), 150);
      else window.scrollTo({ top: 0, behavior: 'smooth' });
    } else if (anchor) {
      scrollToSection(anchor);
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const go = (path) => {
    setMenuOpen(false);
    navigate(path);
  };

  const linkBase =
    'relative bg-transparent border-none cursor-pointer px-4 py-2.5 text-sm font-light tracking-[0.12em] text-cv-ink hover:text-cv-accent transition-colors';
  const underline = <span className="absolute bottom-1 left-1/2 -translate-x-1/2 w-6 h-px bg-cv-accent" />;

  return (
    <header
      className="fixed top-0 left-0 right-0 z-50 border-b border-cv-border"
      style={{ background: 'rgba(250,247,242,0.92)', backdropFilter: 'blur(12px)' }}
    >
      <div className="max-w-[1200px] mx-auto flex items-center justify-between gap-6 px-4 sm:px-6 lg:px-8 py-3.5">
        <button onClick={() => goHome()} className="flex items-center gap-4 bg-none border-none cursor-pointer p-0 text-left">
          <img src="/logo.jpg" alt="CHills Visuella" className="w-[46px] h-[46px] rounded-full object-cover border border-cv-edge2" />
          <span className="flex flex-col gap-0.5">
            <span className="font-serif text-[22px] tracking-[0.18em] text-cv-ink">
              CHills <em className="not-italic font-normal">visuella</em>
            </span>
            <span className="text-[10px] tracking-[0.32em] uppercase text-cv-accent">Kreativ Design</span>
          </span>
        </button>

        <nav className="hidden lg:flex items-center gap-1.5">
          <button onClick={() => goHome()} className={linkBase}>Hem{onHome && underline}</button>
          <button onClick={() => goHome('services-section')} className={linkBase}>Portfolio{onService && underline}</button>
          <button onClick={() => goHome('reviews-section')} className={linkBase}>Omdömen</button>
          <button onClick={() => go('/om')} className={linkBase}>Om mig{onAbout && underline}</button>
          <button
            onClick={() => go('/kontakt')}
            className="ml-4 bg-cv-ink text-cv-base border-none cursor-pointer px-7 py-3 text-[13px] tracking-[0.18em] uppercase font-normal rounded-cv hover:bg-cv-ink2 transition-colors"
          >
            Kontakt
          </button>
        </nav>

        <button
          onClick={() => setMenuOpen((o) => !o)}
          aria-label="Meny"
          className="lg:hidden flex flex-col items-center justify-center gap-[5px] w-11 h-11 bg-none border-none cursor-pointer p-0"
        >
          <span className={`block w-[22px] h-[1.5px] bg-cv-ink transition-all ${menuOpen ? 'translate-y-[6.5px] rotate-45' : ''}`} />
          <span className={`block w-[22px] h-[1.5px] bg-cv-ink transition-all ${menuOpen ? 'opacity-0' : 'opacity-100'}`} />
          <span className={`block w-[22px] h-[1.5px] bg-cv-ink transition-all ${menuOpen ? '-translate-y-[6.5px] -rotate-45' : ''}`} />
        </button>
      </div>

      {menuOpen && (
        <nav className="lg:hidden border-t border-cv-border flex flex-col px-4 sm:px-6 pb-4 pt-2" style={{ background: 'rgba(250,247,242,0.98)' }}>
          <button onClick={() => goHome()} className="text-left bg-none border-none border-b border-cv-line cursor-pointer py-4 px-1 text-[15px] font-light tracking-[0.14em] text-cv-ink">Hem</button>
          <button onClick={() => goHome('services-section')} className="text-left bg-none border-none border-b border-cv-line cursor-pointer py-4 px-1 text-[15px] font-light tracking-[0.14em] text-cv-ink">Portfolio</button>
          <button onClick={() => goHome('reviews-section')} className="text-left bg-none border-none border-b border-cv-line cursor-pointer py-4 px-1 text-[15px] font-light tracking-[0.14em] text-cv-ink">Omdömen</button>
          <button onClick={() => go('/om')} className="text-left bg-none border-none border-b border-cv-line cursor-pointer py-4 px-1 text-[15px] font-light tracking-[0.14em] text-cv-ink">Om mig</button>
          <button onClick={() => go('/kontakt')} className="text-left bg-none border-none cursor-pointer py-4 px-1 text-[15px] font-normal tracking-[0.14em] uppercase text-cv-accent">Kontakt</button>
        </nav>
      )}
    </header>
  );
};
